import { ChartTreeIcon } from './ChartTreeIcon';

/**
 * author: Google
 * id B7E7AEAC-4A67-4C0F-8A4C-C0955AE5F655
 * name chart-tree
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-tree.svg
 * tags
 * - Math 
 */
export const ReportTreeIcon = ChartTreeIcon;
export default ReportTreeIcon